import { useState, useEffect } from 'react'

export const useObfuscatedContact = () => {
    const [contact, setContact] = useState({
        phone: '',
        email1: '',
        email2: '',
        address: null
    })

    useEffect(() => {
        const phone = ['+','1',' ','(','5','1','6',')',' ','2','8','8',' ','9','0','1','8'].join('')
        const email1 = ['i','n','f','o','@','l','i','n','k','o','l','a','b','s','.','c','o','m'].join('')
        const email2 = ['d','a','v','i','d','s','o','n','e','c','o','n','o','m','i','c','s','@','g','m','a','i','l','.','c','o','m'].join('')
        const address = {
            company: ['L','i','n','k','o',' ','L','a','b','s',' ','L','L','C'].join(''),
            street: ['1','0','9','5',' ','S','u','g','a','r',' ','V','i','e','w',' ','D','r',' ','S','t','e',' ','5','0','0'].join(''),
            city: ['S','h','e','r','i','d','a','n',',',' ','W','Y',' ','8','2','8','0','1'].join(''),
            country: ['U','n','i','t','e','d',' ','S','t','a','t','e','s'].join('')
        }
        setContact({ phone, email1, email2, address })
    }, [])

    return contact
}
